import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Component/HeaderFooter/Header';
import Footer from './Component/HeaderFooter/Footer';
import Home from './Component/MainPage/Home';
import ContactUs from './Component/MainPage/ContactUs';
import AboutUs from './Component/MainPage/AboutUs';
import Services from './Component/MainPage/Services';

function App() {
  return (
    <Router>
    <Header />
    
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact_us" element={<ContactUs />} />
      <Route path="/about_us" element={<AboutUs />} />
    </Routes>
    
    <Footer />
  </Router>
  );
}

export default App;
